// extracted by mini-css-extract-plugin
export default {"input":"input_input__zRdGF","select":"input_select__z6TDg"};